import styled from 'styled-components';
import { IoIosArrowDown } from 'react-icons/io';

export const ItemHeader = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  padding: 1rem;

  ${props => props.$expanded && `
    color: orange;
  `}
`;

export const ArrowUp = styled(IoIosArrowDown)`
  transform: rotate(180deg);
`;

export const ArrowDown = styled(IoIosArrowDown)``;
